/* tslint:disable */
/* eslint-disable */
/**
 * MTX Brokerage API
 * Brokerage agent-facing API for dispositions, listings, and transactions
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { OfferTerminationReason } from './OfferTerminationReason';
import {
    OfferTerminationReasonFromJSON,
    OfferTerminationReasonFromJSONTyped,
    OfferTerminationReasonToJSON,
} from './OfferTerminationReason';

/**
 * 
 * @export
 * @interface OfferOfferTerminationReason
 */
export interface OfferOfferTerminationReason {
}

/**
 * Check if a given object implements the OfferOfferTerminationReason interface.
 */
export function instanceOfOfferOfferTerminationReason(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function OfferOfferTerminationReasonFromJSON(json: any): OfferOfferTerminationReason {
    return OfferOfferTerminationReasonFromJSONTyped(json, false);
}

export function OfferOfferTerminationReasonFromJSONTyped(json: any, ignoreDiscriminator: boolean): OfferOfferTerminationReason {
    return json;
}

export function OfferOfferTerminationReasonToJSON(value?: OfferOfferTerminationReason | null): any {
    return value;
}

